<div class="qandaBox" malihu-scrollbar>
    <div class="qandaBox-alert-wrapper">
        <div [ngClass]="{active: isDeleted}" class="qandaBox-alert">
             <p>{{notificationMsg}}</p>
            <a title="Close" (click)="hideNotification()" class=""><i class="icon-close"></i></a>
        </div> 
    </div>
    <p class="mb-0 notes d-lg-none">Q&amp;A 
        <a href="javascript:void(0)" (click)="onClose()" class="icon-close tabsClosed"></a>
    </p>
    <div class="qandaBox__header">
        <div class="text-input-block">
            <div class="text-input-group">
                <textarea [(ngModel)]="message"  placeholder="Write your question here" class="text-input" cols="3" rows="3"></textarea>
            </div>
            <div class="text-right">
                <button (click)="addPost()" [disabled]="submitQuestionEnable" class="text-input-btn">SUBMIT</button>
            </div>
        </div>
    </div>
    <div class="qandaBox__body">
        <div *ngIf="messages && messages?.length == 0" class="qandaBox__empty">
            <div class="text-center">
                <img class="qandaBox__empty-pic" src="assets/images/qanda/empty-qa.svg" alt="">
                <h1 class="qandaBox__empty-title">There are no posts or comments yet</h1>
                <p class="qandaBox__empty-subtitle"></p>
            </div>
        </div>
        <div *ngIf="messages?.length > 0"  class="qandaBox-item">
            <div class="qandaBox-item__inner" *ngFor="let msg of messages; index as i">
                <div class="qandaBox-profile">
                    <ngx-avatar size="45" name="{{msg?.users[0]?.name}}" class="qandaBox-profile__pic"></ngx-avatar>
                    <!-- <img title="{{user?.email}}" class="qandaBox-profile__pic" src="https://ui-avatars.com/api/?background=random&size=50&rounded=true&name={{msg?.users[0]?.name}}"> -->
                    <div class="qandaBox-profile__desc">
                        <h3 title="{{user?.email}}" class="qandaBox-profile__title">{{msg?.users[0]?.name}}</h3><span  *ngIf="msg?.users[0]?.isAdmin" class="qandaBox-profile__tag">Moderator</span>
                        <p title="{{getTimeStamp(msg.created)}}" class="qandaBox-profile__subtitle mb-1">{{getTimeStamp(msg.created)}}</p>
                    </div>

                    <div class="qandaBox-menu">
                        <a href="javascript:void(0)" class="qandaBox-menu__btn"><i class="icon-dots"></i></a>
                        <div class="qandaBox-menu__dropdown">
                            <ng-container *ngIf="msg?.isAuthor || user?.isAdmin">
                                <a title="Edit" (click)="editPost(msg,i)">Edit</a>
                                <a title="Delete" (click)="deletePost(msg,i)">Delete</a>
                            </ng-container>
                            <a title="report" *ngIf="!msg?.isFlag && !msg?.isAuthor" (click) ="flagPost(msg,i)">Report</a>
                        </div>
                    </div>
                </div>
                <p  *ngIf="!msg.isEditPost" class="qandaBox__message">{{msg?.question}}</p>
                <ng-container *ngIf="msg.isEditPost"> 
                    <textarea [(ngModel)]="updatedPostMessage" (keyup.enter)="addPostMessage(msg,i)"  placeholder="Write your reply here" class="text-input text-input--small" cols="3" rows="3"></textarea>
                    <div class="text-right">
                        <a title="Update" (click)="addPostMessage(msg,i)" class="qandaBox-profile__link">Update</a>
                        <a title="Cancel" (click)="cancelMsg(msg,i)" class="qandaBox-profile__link">Cancel</a>
                    </div>
                </ng-container>
                <div class="d-flex align-items-center justify-content-between">
                    <ul class="qandaBox__clicks">
                        <li *ngIf="msg?.isLike"><a title="Like" class="active" appDebounce [debounceTime]="800" (debounceClick)="addLikePost(msg,i,'unlike')" >{{msg?.likeCounter}} <i class="icon-like"></i></a></li>
                        <li *ngIf="!msg?.isLike"><a title="Like" appDebounce [debounceTime]="800" (debounceClick)="addLikePost(msg,i,'like')" >{{msg?.likeCounter}} <i class="icon-like"></i></a></li>
                        <li><a title="Comment" (click) = "showComments(msg,i)">{{msg?.commentsCounter}} <i class="icon-comment"></i></a></li>
                        <!-- <li *ngIf="msg?.isFlag" ><a>{{msg?.flagsCounter}} <i class="icon-outlined-flag"></i></a></li>
                        <li *ngIf="!msg?.isFlag"><a (click) ="flagPost(msg,i)">{{msg?.flagsCounter}} <i class="icon-outlined-flag"></i></a></li> -->
                    </ul>        
                    <!-- <ul *ngIf="msg?.isAuthor || user?.isAdmin" class="qandaBox__clicks">
                        <li>< title="Delete"a (click)="deletePost(msg,i)"><i class="icon-delete"></i></a></li>
                        <li>< title="Edit"a (click)="editPost(msg,i)"  ><i class="icon-edit"></i></a></li>
                    </ul>         -->
                </div>
                <ng-container *ngIf="msg?.showComments">
                    <div class="qandaBox-profile pt-3">
                        <ngx-avatar size="45" name="{{users?.name}}" class="qandaBox-profile__pic"></ngx-avatar>
                        <!-- <img title="User Email" class="qandaBox-profile__pic" src="https://ui-avatars.com/api/?background=random&size=50&rounded=true&name={{user?.name}}"> -->
                        <div class="qandaBox-profile__desc">
                            <div class="text-input-group mb-1">
                                <textarea [(ngModel)]="commentText" placeholder="Write your reply here" class="text-input text-input--small" cols="3" rows="3"></textarea>
                            </div>
                            <div class="text-right">
                                <a title="Reply" [ngClass]="replyButtonEnable?'pointer-events-none':''" (click)="addReply(msg)" class="qandaBox-profile__link">REPLY</a>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="msg?.commentsCounter > 0 && msg?.showComments ">
                    <div  *ngFor="let comment of msg?.comments; index as j" class="qandaBox-profile pt-3">
                        <ngx-avatar size="45" name="{{comment?.users[0]?.name}}" class="qandaBox-profile__pic"></ngx-avatar>
                        <!-- <img title="{{user?.email}}" class="qandaBox-profile__pic" src="https://ui-avatars.com/api/?background=random&size=50&rounded=true&name={{msg?.users[0]?.name}}"> -->
                        <div class="qandaBox-profile__desc">
                            <h3 class="qandaBox-profile__title">{{comment?.users[0]?.name}} <span  *ngIf="comment?.users[0]?.isAdmin" class="qandaBox-profile__tag">Moderator</span></h3>
                            <p class="qandaBox-profile__subtitle pb-1">{{getTimeStamp(comment.created)}}</p>
                            <p *ngIf="!comment?.isEditComment" class="qandaBox__message">{{comment?.description}}</p>
                            <ng-container *ngIf="comment?.isEditComment">
                                <textarea [(ngModel)]="updatedPostComment" (keyup.enter)="addPostComment(comment,msg,j)"  placeholder="Write your reply here" class="text-input text-input--small" cols="3" rows="3"></textarea>
                                <div class="text-right">
                                    <a title="Update" (click)="addPostComment(comment,msg,j)" class="qandaBox-profile__link">Update</a>
                                    <a title="Cancel" (click)="cancelComment(comment,msg,j)" class="qandaBox-profile__link">Cancel</a>
                                </div>
                            </ng-container>
                            <div class="d-flex align-items-center justify-content-between">
                                <ul class="qandaBox__clicks">
                                    <li *ngIf="!comment?.isLike" ><a title="like" appDebounce [debounceTime]="800" (debounceClick)="addLikeComment(comment , msg,j)"> {{comment?.likeCounter}}<i class="icon-like"></i></a></li>
                                    <li *ngIf="comment?.isLike" ><a title="like"  appDebounce [debounceTime]="800" (debounceClick)="addLikeComment(comment , msg,j)"> {{comment?.likeCounter}}<i class="icon-like"></i></a></li>
                                    <!-- <li *ngIf="!comment?.isFlag"><a title="Report" (click)="flagComment(comment , msg , j)">{{comment?.flagCounter}}<i class="icon-outlined-flag"></i></a></li>
                                    <li *ngIf="comment?.isFlag"><a title="Report">{{comment?.flagCounter}}<i class="icon-outlined-flag"></i></a></li> -->
                                </ul>        
                                <!-- <ul  *ngIf="comment?.isAuthor || user?.isAdmin"  class="qandaBox__clicks">
                                    <li><a (click) ="deleteComment(comment,msg,j)"><i class="icon-delete"></i></a></li>
                                    <li>< title="Edit"a (click)="editComment(comment,msg,j)" ><i class="icon-edit"></i></a></li>
                                </ul> -->
                            </div>
                            <div *ngIf="comment?.isAuthor || user?.isAdmin" class="qandaBox-menu" style="top: 13px;">
                                <a href="javascript:void(0)" class="qandaBox-menu__btn"><i class="icon-dots"></i></a>
                                <div class="qandaBox-menu__dropdown">
                                    <a title="Edit" (click)="editComment(comment,msg,j)">Edit</a>
                                    <a title="Delete" (click)="deleteComment(comment,msg,j)">Delete</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                
            </div>

            <!-- <div class="qandaBox-profile">
                <i title="User Email"mg src="qandaBox-profile__pic" src="assets/images/qanda/user.png">
                <div class="qandaBox-profile__desc">
                    <h3 class="qandaBox-profile__title">John Doe <span class="qandaBox-profile__tag">Admin</span></h3>
                    <p class="qandaBox-profile__subtitle">3h ago</p>
                    <p class="qandaBox__message">Does this course give a certificate?</p>
                    <div class="d-flex align-items-center justify-content-between pd-t10 pd-b10">
                        <ul class="qandaBox__clicks">
                            <li><a>1 <i class="icon-like"></i></a></li>
                            <li><a (click)="showComments(msg)"><i class="icon-reply"></i></a></li>
                            <li><a>3 <i class="icon-outlined-flag"></i></a></li>
                        </ul>        
                        <ul class="qandaBox__clicks">
                            <li><a href="#"><i class="icon-delete"></i></a></li>
                            <li><a href="#"><i class="icon-edit"></i></a></li>
                        </ul>        
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>
